import React, {useEffect, useState} from 'react';
import queryString from 'query-string';
import {addFlashMessage} from '../../actions/flash-message';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import ChangePasswordForm from './ChangePasswordForm';


function ChangePasswordContainer(props, context){
    const token = queryString.parse(location.search).token;
    const {addFlashMessage} = props;
    const {router} = context;
    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState('');

    const successAction = (message, success) => {
        setSuccess(success);
        setMessage(message);
    };

    useEffect (() => {
        if (success && message !== '') {
            router.history.push('/login');
        }
        addFlashMessage(message, success ? 'success' : 'error');
    }, [message]);

    return (
        <div className="change-password">
            <ChangePasswordForm addFlashMessage={addFlashMessage} token={token} successAction={successAction}/>
        </div>
    );
}

const mapDispatchToProps = dispatch => ({
    addFlashMessage: (...args) => dispatch(addFlashMessage(...args))
});

ChangePasswordContainer.contextTypes = {
    router: PropTypes.object.isRequired
};

ChangePasswordContainer.propTypes = {
    addFlashMessage: PropTypes.func.isRequired,
};

export default withRouter(connect(null, mapDispatchToProps)(ChangePasswordContainer));